module.exports = __webpack_public_path__ + "static/media/trtl.1671411c.svg";